real.input = (function($, real) {
    'use strict';

    var
        validateIpList,
        validateIpListBlur,
        validateUrl,
        validateUrlBlur,
        validateWorkspaceDomainLocal,
        validateWorkspaceDomainLocalBlur,
        validateEmailLocal,
        validateEmailLocalBlur,
        validateEmail,
        validateEmailBlur,
        validateEmailDisplayName,
        validateMobile,
        validateNumber
    ;

    let validateDomainTimeoutId = null;

    const validateDomain = function(modal, successFn = null, errorFn = null) {
        const domainInput = modal.find('input.workspace-domain');
        const rootDomain = modal.find('.workspace-root-domain');
        const saveBtn = modal.find('.btn-success');

        if (typeof successFn !== 'function') {
            successFn = () => {
                domainInput.removeClass('is-invalid');
                saveBtn.prop('disabled', false);
            };
        }

        if (typeof errorFn !== 'function') {
            errorFn = (response) => {
                if (typeof howspace !== 'undefined' && typeof howspace.form !== 'undefined') {
                    const errorMsg = response && response.status === 409
                        ? 'Another workspace already exists with same domain, please choose another domain.'
                        : undefined;
                    howspace.form.markInvalidField(domainInput, errorMsg);
                } else {
                    domainInput.addClass('is-invalid');
                }
                saveBtn.prop('disabled', true);
            };
        }

        // We don't need to check if the domain is available if it's a freemium workspace, since those will get randomized domain
        if (domainInput.data('freemium')) {
            successFn();
            return;
        }

        const domain = domainInput.val().trim();
        if (domain === '') {
            return;
        }

        const logFn = () => {
            return false;
        };
        const dataPayload = {
            domain: domain + rootDomain.text()
        };
        real.ajax.json(real.baseUri + '/api/check/workspace-domain', {
            type : 'POST',
            data : JSON.stringify(dataPayload),
            success : successFn,
            logError : logFn,
            showErrorNotification : logFn,
            error : errorFn
        });
    };

    validateIpList = function(val) {
        val = val.toLowerCase();

        // A list of IP addresses input can contain numbers, slashes, periods, commas and spaces.
        val = val.replace(/[^0-9\/\,\. ]/g, '');

        return val;
    };

    validateIpListBlur = function(val) {
        // First validate IP list.
        val = validateIpList(val);

        var fixedIps = [];
        val.split(',').forEach(function(ipAddress) {
            // Keep only valid IP addresses.
            var
                arr,
                parts,
                allPartsValid = true,
                bitmask = null
            ;

            arr = ipAddress.split('/');
            if(arr.length > 2) {
                // Found too many / characters, only one is allowed.
                return;
            }

            if(arr.length === 2) {
                bitmask = parseInt(arr[1]);
                if(bitmask < 0 || bitmask > 32) {
                    // The given bitmask is not valid.
                    return;
                }
            }

            parts = arr[0].split('.');
            if(parts.length !== 4) {
                // IPv4 address needs always four parts.
                return;
            }

            parts.forEach(function(part, i) {
                parts[i] = part.trim();
                part = parseInt(parts[i]);
                if(part < 0 || part > 255) {
                    // Some part is not withing 0-255 range.
                    allPartsValid = false;
                }
            });

            if(!allPartsValid) {
                return;
            }

            ipAddress = parts.join('.');
            if(bitmask !== null) {
                ipAddress += '/' + bitmask;
            }

            // Once we get this far we are confident that the IP is valid.
            // Push fixed IP back to fixed ip addresses array.
            fixedIps.push(ipAddress);
        });

        // Return fixed IP addresses as a comma separated list.
        return fixedIps.join(', ');
    };

    validateUrl = function(val) {
        val = val.toLowerCase();

        /**
         * According to RFC 1738 specification:
         *
         * Thus, only alphanumerics, the special characters "$-_.+!*'(),", and
         * reserved characters used for their reserved purposes may be used
         * unencoded within a URL.
         *
         * http://www.faqs.org/rfcs/rfc1738.html
         */
        //val = val.replace(/[^a-z0-9\$\-_\.\+\!\*'\(\)]/g, '');

        // Not using the above, instead we force all urls to be lowercase
        // alphanumerics and we allow hyphen "-" and period "." characters.
        val = val.replace(/[^a-z0-9\-\.]/g, '');

        // Hyphens and periods cannot be directly followed by other hyphen or period.
        val = val.replace(/\-[\-\.]+/, '-');
        val = val.replace(/\.[\-\.]+/, '.');

        return val;
    };

    validateUrlBlur = function(val) {
        // First validate url.
        val = validateUrl(val);

        // Then remove periods and hyphens from the beginning and end.
        val = val.replace(/^[\-\.]/, '');
        val = val.replace(/[\-\.]$/, '');

        return val;
    };

    validateWorkspaceDomainLocal = function(val) {
        val = val.toLowerCase();
        val = val.replace(/\./g, '');
        val = val.replace(/\s+/g, '-');
        val = val.replace(/_/g, '-');
        val = val.replace(/\-+/g, '-');

        // Replace special characters like ë, ä, ö, å, etc. with their ASCII equivalents.
        const specialChars = {
            'ä': 'a',
            'å': 'a',
            'â': 'a',
            'á': 'a',
            'à': 'a',
            'æ': 'ae',
            'ç': 'c',
            'ð': 'dh',
            'ë': 'e',
            'é': 'e',
            'è': 'e',
            'ê': 'e',
            'í': 'i',
            'î': 'i',
            'ñ': 'n',
            'ö': 'o',
            'ó': 'o',
            'ô': 'o',
            'ø': 'o',
            'œ': 'oe',
            'ß': 'ss',
            'þ': 'th',
            'ü': 'u',
            'ú': 'u',
            'ù': 'u',
            'û': 'u',
            'µ': 'u',
            'ÿ': 'y',
        }

        for (let key in specialChars) {
            val = val.replace(new RegExp(key, 'g'), specialChars[key]);
        }

        val = validateUrl(val);

        return val;
    };

    validateWorkspaceDomainLocalBlur = function(val) {
        val = validateWorkspaceDomainLocal(val);
        val = val.replace(/^[\-]*/, '');
        val = val.replace(/[\-]*$/, '');
        return val;
    };

    validateEmailLocal = function(val) {
        val = val.toLowerCase();
        val = val.replace(/\s+/g, '-');
        val = val.replace(/ä/g, 'a');
        val = val.replace(/ö/g, 'o');
        val = val.replace(/å/g, 'a');
        val = val.replace(/[^a-z0-9\!#\$%&'\*\+\-\/\=\?\^_`\.\{\|\}~]/g, '');
        return val;
    };

    validateEmailLocalBlur = function(val) {
        // First validate email local part.
        val = validateEmailLocal(val);

        // Then remove period from beginning and end.
        val = val.replace(/^[\.]*/, '');
        val = val.replace(/[\.]*$/, '');

        return val;
    };

    validateEmail = function(val) {
        var parts;

        val = val.toLowerCase();
        parts = val.split('@');

        val = validateEmailLocal(parts[0]);
        if(parts.length > 1) {
            parts[1] = validateUrl(parts[1].replace(/@/g, ''));
            val += '@' + parts[1];
        }

        return val;
    };

    validateEmailBlur = function(val) {
        var parts;

        val = val.toLowerCase();
        parts = val.split('@');

        val = validateEmailLocalBlur(parts[0]);
        if(parts.length > 1) {
            parts[1] = validateUrlBlur(parts[1].replace(/@/g, ''));
            val += '@' + parts[1];
        }

        return val;
    };

    validateEmailDisplayName = function(val) {
        // Allow alphanumeral, space, period, @, dash, underscore, brackets, sinqle quote and Latin-1 Supplement unicode block
        return val.replace(/[^0-9a-z\s\.@\-_\(\)\'\u0080-\u00FF]/gi, '');
    };

    validateMobile = function(val) {
        var startsWithPlus = false;

        val = real.trim(val.toLowerCase());

        if(val.substring(0, 1) === '+') {
            startsWithPlus = true;
        }

        // Force numeric content, allow one plus in the beginning
        val = val.replace(/[^0-9]/g, '');

        if(startsWithPlus) {
            val = '+' + val;
        }

        if(val === '') {
            return val;
        }

        return val;
    };

    validateNumber = function(val) {
        // Replace commas with periods and force numeric content.
        return val.replace(/\,/g, '.').replace(/[^0-9\.]/g, '');
    };

    return {

        validateIpList : function(e) {
            var input = $(this);
            var fixedValue = validateIpList(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateIpListBlur : function(e) {
            var input = $(this);
            var fixedValue = validateIpListBlur(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateUrl : function(e) {
            var input = $(this);
            var fixedValue = validateUrl(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateUrlFromString : validateUrl,

        validateUrlBlur : function(e) {
            var input = $(this);
            var fixedValue = validateUrlBlur(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateWorkspaceDomainLocal : function(e) {
            var input = $(this);
            var fixedValue = validateWorkspaceDomainLocal(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateWorkspaceDomainLocalBlur : function(e) {
            var input = $(this);
            var fixedValue = validateWorkspaceDomainLocalBlur(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateWorkspaceDomain : (modal, successFn = null, errorFn = null) => {
            if (validateDomainTimeoutId) {
                clearTimeout(validateDomainTimeoutId);
            }
            validateDomainTimeoutId = setTimeout(function () {
                validateDomain(modal, successFn, errorFn);
            }, 500);
        },

        validateEmailLocal : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateEmailLocal(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateEmailLocalBlur : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateEmailLocalBlur(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateEmailDisplayName : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateEmailDisplayName(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateEmail : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateEmail(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateEmailBlur : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateEmailBlur(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateMobile : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateMobile(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateNumber : function(e) {
            var input, fixedValue;

            input = $(this);
            fixedValue = validateNumber(input.val());
            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateMin : function(e) {
            var input, fixedValue, min;

            input = $(this);

            if(e.type !== 'blur' && input.val().trim() === '') {
                return;
            }

            fixedValue = validateNumber(input.val());
            min = parseFloat(input.attr('min'));

            if(input.val().trim() === '' || parseFloat(fixedValue || 0) < min) {
                fixedValue = min;
            }

            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        validateMax : function(e) {
            var input, fixedValue, max;

            input = $(this);

            if(e.type !== 'blur' && input.val().trim() === '') {
                return;
            }

            fixedValue = validateNumber(input.val());
            max = parseFloat(input.attr('max'));

            if(input.val().trim() === '' || parseFloat(fixedValue || 0) > max) {
                fixedValue = max;
            }

            if(fixedValue !== input.val()) {
                input.val(fixedValue);
            }
        },

        focus : function(input) {
            if (input instanceof jQuery) {
                input = input[0];
            }
            if (!input) {
                return;
            }
            input.focus();

            try {
                // Check if input supports setSelectionRange
                if(input.setSelectionRange) {
                    // Try to put selection to the end of the input
                    input.setSelectionRange(input.value.length, input.value.length);
                    return;
                }

                const range = document.createRange();
                const sel = window.getSelection();

                const getLastChild = function(elem) {
                    if(elem.lastChild) {
                        return getLastChild(elem.lastChild);
                    }
                    return elem;
                };

                const lastChild = getLastChild(input[0]);
                range.setStart(lastChild, lastChild.textContent.length);
                sel.removeAllRanges();
                sel.addRange(range);
            } catch (e) {
                // Fallback to empty + restore orig value trick in case of error
                // (for example input type email doesn't support setSelectionRange)
                try {
                    var orig = input.val();
                    input.val('');
                    input.val(orig);
                } catch (e) {
                    // ...or just fail silently if that doesn't work either
                }
            }
        }
    };

})(jQuery, real);
